import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import nextArrow from "../../assets/nextArrow.png";
import { useRef } from "react";
import paymenticon from "../../assets/paymentsIcon.png";
import Tagpay from "../../assets/tagpayicon.png";
import GlobalSearchHeader from "../Header/GlobalSearchHeader";
import Aboutusicon from "../../assets/aboutusicon.png";
import faqicon from "../../assets/faqicon.png";
import usericon from "../../assets/user.png";
import TagIcon from "../../assets/tagpayicon.png";
import GiftCard from '../../assets/giftCard.png'

import BottomNarBar from "../BottomNav/Bottom";
import helpfaq from "../../assets/helpfaq.png";
import ReferICon from "../../assets/refericon.png"
import "./userprofile.css";
import GooglePopupContainer from '../Google_Popup_number/container'

function Userprofile(props) {
  const [timeLeft, setTimeLeft] = useState(30); // Initial timer value
  const [canResend, setCanResend] = useState(false);


  const inputRef = useRef(null); 
  const inputOtpRef = useRef(null); 
  const handleNumber = (e) => {
    props&&props.setNumber(e.target.value);
    console.log(e.target.value) // Update state with the input value
  };

  const handleOtp = (e) => {
    props&&props.setOtp(e.target.value);
    console.log(e.target.value) // Update state with the input value
  };

  console.log("props&&props.otp",props&&props.otp)

  useEffect(() => {
    if (inputOtpRef.current) {
      inputOtpRef.current.focus(); // Automatically focus on the input field
    }
  }, [props&&props.otp]); 
  // Keep focus on the input field after re-renders
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Automatically focus on the input field
    }
  }, [props&&props.number]); // Dependency ensures this runs after state updates

    // Keep focus on the input
  console.log("props Userprofile", props);
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  const navigator = useNavigate();
  const [logoutModal, setLogutModal] = useState(false);
//
const [logoutBtn, setLogoutBtn] = useState(false);
const goToGiftCard=()=>{
  navigator('/giftcard')
}
useEffect(()=>{
  window.scrollTo(0, 0); 
},[])
  const TopNav = () => {
    return (
      <>
        <div className="_2456r">
          <div
            className="_3nxa7"
            style={{ "align-items": "center" }}
            data-testid="listing-header-location"
          >
            <button
              className="_1NdRR"
              aria-label="Selected address is Delhi, India; Double tap to change address."
              id="change-address-btn-id"
            >
              <div style={{ display: "flex", "align-items": "center" }}>
                <h2
                  style={{
                    marginLeft: "25px",
                    fontSize: "18px",
                    color: "#583C43",
                    fontWeight: "500",
                  }}
                >
                  Profile
                </h2>

                <div style={{ marginLeft: "10px" }}></div>
              </div>
            </button>

            <span className="icon-Offers-outline _2P0Ff" />

          <div onClick={(e)=>{setLogoutBtn(true)}}><svg

              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 3.25C8.41421 3.25 8.75 2.91421 8.75 2.5C8.75 2.08579 8.41421 1.75 8 1.75C7.58579 1.75 7.25 2.08579 7.25 2.5C7.25 2.91421 7.58579 3.25 8 3.25Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 8.75C8.41421 8.75 8.75 8.41421 8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 14.25C8.41421 14.25 8.75 13.9142 8.75 13.5C8.75 13.0858 8.41421 12.75 8 12.75C7.58579 12.75 7.25 13.0858 7.25 13.5C7.25 13.9142 7.58579 14.25 8 14.25Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            </div> 
          </div>
        </div>
      </>
    );
  };
  const LogoutModalFun = () => {
    setLogutModal(true);
    setLogoutBtn(false)
  };
const DeviceCount=()=>{
  if(props&&props.profileData&&props.profileData.activeSessionCount&&props.profileData.activeSessionCount.length==1){
return props&&props.profileData&&props.profileData.activeSessionCount&&props.profileData.activeSessionCount
  }
  else{
    return `${props&&props.profileData&&props.profileData.activeSessionCount&&props.profileData.activeSessionCount}`
  }
}


const AddGoogleNumber=()=>{
  
  return(<>
  

    { <div className="modal">
      
        
        <div style={{display:"flex",justifyContent:"center"}}>
      <div style={{padding:"5%",marginTop:"20%",    width: "90%"}}>

            <div style={{background:"white",widows:"100%" ,height:"80vw",borderRadius:"10px"}}>

            <div style={{display:"flex",justifyContent:"center",position: "relative",
  top:"-70px"}}><svg style={{    width: "90px"}} xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124" fill="none">
<g clip-path="url(#clip0_83_382)">
<path d="M79.4837 103.027C102.384 93.125 112.921 66.5329 103.019 43.6324C93.1164 20.732 66.5243 10.195 43.6238 20.0974C20.7233 29.9998 10.1863 56.5919 20.0888 79.4924C29.9912 102.393 56.5832 112.93 79.4837 103.027Z" fill="#009846"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M45.9086 38.8813L53.7773 45.6473C53.7773 45.6473 55.6852 47.8822 54.5372 49.9086C48.2219 61.1602 65.447 75.9554 75.6141 68.0047C77.4648 66.569 79.9435 68.1099 79.9435 68.1099L87.8122 74.8758C93.2011 78.9009 80.8114 88.1892 71.4763 84.9996C62.749 82.018 54.1075 74.0091 53.012 72.9999C51.8431 72.0931 42.6223 64.7585 38.3547 56.5766C33.7987 47.8368 41.0905 34.1622 45.8888 38.8899L45.9086 38.8813Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_83_382">
<rect width="93.6566" height="93.6566" fill="white" transform="translate(0 37.1719) rotate(-23.3842)"/>
</clipPath>
</defs>
</svg></div>

<div style={{position:"relative",top:"-91px",textAlign:"center",padding:"0%"}}>



<h1 style={{fontSize:"16px",fontWeight:"700"}}>Verify Your Number</h1>
<div style={{display:"flex",justifyContent:"center"}}>
<p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%",width:"80%"}}>Please enter your phone number to link it and continue to payment.</p>

</div>

<div style={{display:"flex",justifyContent:"center"}}>
<div style={{border:"2px solid #8080805e",borderRadius:"10px",marginTop:"7%",    width: "80%"}}>
<input   ref={inputRef}  type="number" min="0" inputmode="numeric" pattern="[0-9]*" title="Non-negative integral number"  style={{padding:"2%",paddingLeft:"0%", fontSize:"16px",marginLeft:"-8vw",}} value={props&&props.number} 
 onChange={(e)=>{handleNumber(e)}} 
placeholder="Your Mobile Number" />
</div>
</div>
<div style={{display:"flex",paddingLeft:"10%"}}>
{props&&props.numberError&&<p style={{color:"rgba(234, 67, 53, 1)",textAlign:"start",marginTop:"3%",fontSize:"12px"}}>{props&&props.numberErrorMsg}</p>}
</div>

<div style={{display:"flex",justifyContent:"center"}}>
<div style={{display:"flex",    justifyContent:"space-between",     marginTop:props&&props.numberError?"7%":"15%",   width: "80%"}}>
  <button style={{    padding:" 0%",
  width: "48%",
  border: "2px solid rgba(0, 177, 119, 1)",
  textAlign: "center",
  borderRadius: "10px",color:"rgba(0, 177, 119, 1)"}}  onClick={(e)=>props&&props.closePop(e)} >
  Cancel
  </button>

  <button   onClick={props&&props.googleAddnumber} style={{    padding:" 5%",
  width: "48%",
 
  textAlign: "center",
  borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
  Continue
  </button>
</div>
</div>

</div>



            </div>
      
         
          </div>
          </div>
          </div>}
  
  
  </>)
}



const GoogleNumberOtp=()=>{
  const [time, setTime] = useState(30); // Timer value
  const [inputValue, setInputValue] = useState(""); // User input
  const inputRef = useRef(null); // Reference to the input field

  // Timer logic
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0)); // Countdown
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  // Focus on the input field when the component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // Handle resend button click
  const handleResend = () => {
    props&&props.googleAddnumber()// Hide the "Resend" button
    setTime(30); // Reset timer
    setInputValue(""); // Clear input
    if (inputRef.current) {
      inputRef.current.focus(); // Focus back on input
    }
  };

  return(
  <>

  <div className="modal">

<div style={{display:"flex",justifyContent:"center"}}>
  
  <div style={{padding:"5%",marginTop:"20%",    width: "90%"}}>

        <div style={{background:"white",widows:"100%" ,height:"90%",borderRadius:"10px"}}>

        <div style={{display:"flex",justifyContent:"center",position: "relative",
top:"-35px"}}>

<svg  style={{width:"84px"}}  xmlns="http://www.w3.org/2000/svg" width="142" height="66" viewBox="0 0 142 66" fill="none">
<g clip-path="url(#clip0_61_2282)">
<rect width="142" height="66" rx="33" fill="white"/>
<path d="M112.017 21.564C109.527 21.564 107.503 23.6012 107.503 26.1084V30.5345H116.54V26.1084C116.54 23.6012 114.506 21.564 112.017 21.564Z" fill="#029646"/>
<path d="M124.558 0H17.4418C7.85532 0 0 7.88827 0 17.5076V48.3694C0 58.0039 7.85532 65.877 17.4418 65.877H124.558C134.145 65.877 142 58.0039 142 48.3694V17.5076C142 7.88827 134.145 0 124.558 0ZM37.9472 37.7194L42.1317 42.291L34.8837 47.748L31.9107 42.291C31.4726 41.5119 30.7868 39.984 29.823 37.7194C28.7686 40.2083 28.0677 41.7241 27.7202 42.291L24.705 47.748L17.2545 42.291L21.7592 37.7194C23.0282 36.4613 24.2578 35.382 25.4724 34.4968C24.2337 34.3846 22.6052 34.1542 20.596 33.7752L14.3571 32.7566L17.2515 24.2317L22.8469 26.7843C23.436 27.0511 24.9014 27.8909 27.2338 29.2824C26.7353 27.0178 26.415 25.3352 26.27 24.2317L25.4754 18.1291H34.361L33.6419 24.2317C33.4848 25.7172 33.1404 27.3998 32.6298 29.2824C33.654 28.767 34.3308 28.4244 34.651 28.2365C35.7749 27.6089 36.642 27.1754 37.2251 26.8965L42.8236 24.2317L45.5971 32.7566L39.4065 34.0541C38.2735 34.2724 36.5937 34.4149 34.361 34.4968C35.8746 35.6852 37.059 36.7523 37.9472 37.7194ZM78.9671 37.7194L83.1576 42.291L75.9096 47.7449L72.9397 42.291C72.5016 41.5119 71.8158 39.984 70.855 37.7194C69.7975 40.2083 69.1026 41.7241 68.7552 42.291L65.7339 47.7449L58.2865 42.291L62.7912 37.7194C64.0601 36.4613 65.2868 35.382 66.5043 34.4968C65.2717 34.3846 63.6371 34.1542 61.628 33.7752L55.386 32.7566L58.2835 24.2317L63.8819 26.7843C64.465 27.0511 65.9363 27.8909 68.2657 29.2824C67.7551 27.0178 67.4349 25.3352 67.2989 24.2317L66.5013 18.1351H75.3899L74.6678 24.2317C74.5047 25.7172 74.1663 27.3998 73.6617 29.2824C74.6799 28.767 75.3567 28.4244 75.68 28.2365C76.7978 27.6089 77.668 27.1754 78.2541 26.8965L83.8555 24.2317L86.6321 32.7566L80.4354 34.0541C79.3025 34.2724 77.6287 34.4149 75.3929 34.4968C76.8945 35.6852 78.0819 36.7523 78.9671 37.7194ZM124.93 45.4439C124.93 47.3205 123.398 48.8545 121.531 48.8545H102.512C100.642 48.8545 99.113 47.3205 99.113 45.4439V33.942C99.113 32.0654 100.642 30.5314 102.512 30.5314H102.971V26.1053C102.971 21.094 107.029 17.0165 112.017 17.0165C117.008 17.0165 121.069 21.091 121.069 26.1053V30.5314H121.528C123.392 30.5314 124.927 32.0654 124.927 33.942L124.93 45.4439Z" fill="#029646"/>
</g>
<defs>
<clipPath id="clip0_61_2282">
<rect width="142" height="66" rx="33" fill="white"/>
</clipPath>
</defs>
</svg>
</div>

<div style={{position:"relative",top:"-51px",textAlign:"center",padding:"10%"}}>



<h1 style={{fontSize:"16px",fontWeight:"700"}}>Enter OTP</h1>
<p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%"}}>Enter the 4-digit code sent to your number {props&&props.number}.</p>


<div style={{border:"2px solid #8080805e",borderRadius:"10px",marginTop:"7%"}}>
<input   ref={inputRef} value={props&&props.otp}  style={{padding:"2%",paddingLeft:"0%", fontSize:"16px",marginLeft:"0px",}} type="number" min="0" inputmode="numeric" pattern="[0-9]*" title="Non-negative integral number"  
onChange={(e)=>{handleOtp(e)}} 
placeholder="Please enter the OTP" />
</div>
<div /* tyle={{display:"flex",justifyContent:"start", alignItems:"center",    justifyContent:"space-between"}} */>

<div>
{props&&props.otpError&&<p style={{color:"rgba(234, 67, 53, 1)",textAlign:"start",marginTop:"3%",fontSize:"12px"}}  >{props&&props.otpErrorMsg}</p>}
</div>
<div>
        {time > 0 ? (
         <p  style={{ padding: "", fontSize: "12px",color:"gray" ,textAlign:"center",marginTop:"3%"}}>Didn’t receive code? Resend in {time}s</p>
        ) : (
          <div style={{display:"flex",    "justify-content":"flex-end",
            marginTop: "2vw"}}>
          <button onClick={handleResend} style={{ padding: "", fontSize: "12px",color:"green" }}>
          Resend OTP
        </button>
        </div>
        )}
      </div>
{/* <div><OtpTimer/></div> */}

</div>

<div style={{ fontSize: "16px" }}>

      </div>

<div style={{display:"flex",    justifyContent:"space-between",    marginTop:"15%"}}>
<button style={{    padding:" 0%",
width: "48%",
border: "2px solid rgba(0, 177, 119, 1)",
textAlign: "center",
borderRadius: "10px",color:"rgba(0, 177, 119, 1)"}} onClick={(e)=>props&&props.closeOTpPop(e)} >
Cancel
</button>
<button  onClick={props&&props.googleOtpSubmit}  style={{    padding:" 5%",
width: "48%",

textAlign: "center",
borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
SUBMIT
</button>
</div>

</div>



        </div>
  
     
      </div>
      </div>
      </div>
      </>)
} 


const handleReload = () => {
  localStorage.removeItem("google_jwt")
  setTimeout(() => {
    window.location.reload();
  }, 200);
  // Reloads the current page
};

const GoogleSuccess=()=>{
  return(
  <>
  <div className="modal">

  <div style={{display:"flex",justifyContent:"center"}}>
  <div style={{padding:"5%",marginTop:"20%",    width:"90%"}}>

        <div style={{background:"white",widows:"100%" ,height:"267px",borderRadius:"10px"}}>

        <div style={{display:"flex",justifyContent:"center",position: "relative",
top:"-48px"}}>

<svg style={{    width:"87px"}} xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
<path d="M95 48C95 51.94 88.56 54.98 87.58 58.6C86.58 62.36 90.62 68.2 88.7 71.5C86.76 74.84 79.66 74.26 76.96 76.96C74.26 79.66 74.84 86.78 71.5 88.7C68.2 90.6 62.36 86.56 58.6 87.58C54.96 88.56 51.94 95 48 95C44.06 95 41.02 88.56 37.4 87.58C33.64 86.58 27.8 90.62 24.5 88.7C21.16 86.76 21.74 79.66 19.04 76.96C16.34 74.26 9.22 74.84 7.3 71.5C5.4 68.2 9.44 62.36 8.42 58.6C7.44 54.98 1 51.94 1 48C1 44.06 7.44 41.02 8.42 37.4C9.42 33.64 5.38 27.8 7.3 24.5C9.24 21.16 16.34 21.74 19.04 19.04C21.74 16.34 21.16 9.22 24.5 7.3C27.8 5.4 33.64 9.44 37.4 8.42C41.02 7.44 44.06 1 48 1C51.94 1 54.98 7.44 58.6 8.42C62.36 9.42 68.2 5.38 71.5 7.3C74.84 9.24 74.26 16.34 76.96 19.04C79.66 21.74 86.78 21.16 88.7 24.5C90.6 27.8 86.56 33.64 87.58 37.4C88.56 41.02 95 44.06 95 48Z" fill="#049E79"/>
<path d="M48.0001 78.9201C65.0767 78.9201 78.9201 65.0767 78.9201 48.0001C78.9201 30.9234 65.0767 17.0801 48.0001 17.0801C30.9234 17.0801 17.0801 30.9234 17.0801 48.0001C17.0801 65.0767 30.9234 78.9201 48.0001 78.9201Z" fill="#068463"/>
<path d="M65.6602 36.46C64.1002 34.9 61.5602 34.9 60.0002 36.46L43.2402 53.22L35.3202 45.3C33.7602 43.74 31.2202 43.74 29.6602 45.3C28.1002 46.86 28.1002 49.4 29.6602 50.96L40.4202 61.72C41.1802 62.48 42.2002 62.9 43.2602 62.9C44.3202 62.9 45.3402 62.48 46.1002 61.72L65.6802 42.12C67.2202 40.56 67.2202 38.02 65.6602 36.46Z" fill="white"/>
</svg>
</div>

<div style={{position:"relative",top:"-51px",textAlign:"center",padding:"5%"}}>



<h1 style={{fontSize:"16px",fontWeight:"700"}}>Successful</h1>
<p style={{fontSize:"14px",fontWeight:"400",marginTop:"5%"}}>Your Mobile is Linked. Proceed to payment and enjoy your order.{props&&props.number}.</p>




<div style={{display:"flex",    justifyContent:"space-between",    marginTop:"15%"}}>

<button  onClick={handleReload}  style={{    padding:" 5%",
width: "100%",

textAlign: "center",
borderRadius: "10px",background:" rgba(0, 177, 119, 1)",fontSize:"15px",fontWeight:"700",color:"white"}}>
Done
</button>
</div>

</div>



        </div>
  
     
      </div>
      </div>
      
      </div>
      </>)
}

useEffect(()=>{

  console.log("google_OTP_Pop_flag",props&&props.google_OTP_Pop_flag)

},[props&&props.google_OTP_Pop_flag])









  return (
    <>
   {(props&&props.google_success_flag)&&<GoogleSuccess/>}
   {(props&&props.google_OTP_Pop_flag)&&<GoogleNumberOtp/>}
   
    {(props&&props.google_Pop_flag)&&localStorage.getItem("isGuest")&&<AddGoogleNumber/>}
      {logoutModal && (
        <div className="logoutmodal">
          <div className="modal-content-userprofile">
            <div style={{ display: "flex", "justify-content": "space-around" ,marginBottom:"14px"}}>
              <h1 style={{ fontSize: "21px", fontWeight: "700" }}>
                Log out from ?
              </h1>
            </div>
            <hr />
            <div onClick={(e)=>{props.LogoutCurrentDevice()}}style={{ display: "flex", "justify-content": "space-around", marginBottom:"9px",marginTop:"9px"}}>
              <h1 style={{ fontSize: "12px", fontWeight: "700",color:"#F33051" }}>
              Current Device 
              </h1>
            </div>
            <hr/>
            <div onClick={(e)=>{props.LogoutAllDevice()}} style={{ display: "flex", "justify-content": "space-around" , marginBottom:"9px",marginTop:"9px"}}>
              <h1 style={{ fontSize: "12px", fontWeight: "700",color:"#F33051" }}>
                {console.log("activeSessionCount.length",DeviceCount())}
              All Devices ({DeviceCount()})
              </h1>
            </div>
            <hr/>
            <div onClick={(e)=>{setLogutModal(false)}}style={{ display: "flex", "justify-content": "space-around" ,marginTop:"14px" }}>
              <h1 style={{ fontSize: "12px", fontWeight: "700" ,color:"#64748B"}}>
              Cancel
              </h1>
            </div>
          </div>
        </div>
      )}

      {logoutBtn&&<div
        style={{
          background: "#ffffff",
          position: "fixed",
          "z-index": "99",
          right: "17px",
          width: "95px",
          borderRadius: "8px",
          top: "47px",
        }}
      >
        <div
          style={{
          /*   display: "flex",
            "align-items": "center",
            "justify-content": "space-around", */
            height: "62px",
          }}
        >
          <div>
          <h1
            style={{ textAlign: "center", fontWeight: "500", fontSize: "14px" ,padding:"5px"}}
            onClick={(e) => {
              LogoutModalFun();
            }}
          >
            Log out
          </h1>
          <hr/>
         <Link to="/settings"> <h1
            style={{ textAlign: "center", fontWeight: "500", fontSize: "14px" ,padding:"5px"}}
      
          >
            Settings

          </h1>
          </Link>
          </div>
        </div>
      </div>}
      <TopNav />
      <BottomNarBar />
      <div onClick={(e)=>{setLogoutBtn(false)}}
        style={{
          background:
            "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
          //"paddingBottom":Boolean((props.ActiveOrderItems[0])&&(props.PreCardItems[0]))?"12.5rem":Boolean(props.ActiveOrderItems[0])?"9.5rem":props.PreCardItems[0]&&"8.5rem",
        }}
        className={
          props.login || props.loginOtp
            ? "h-screen overflow-y-auto "
            : "pt-4 pb-36 overflow-y-auto h-screen"
        }
      >
        <div
          style={{
            marginTop: "59px",
            padding: "21px",
            display: "flex",
            "align-items": "center",
            "justify-content": "flex-star",
            fontFamily: "Roboto",
          }}
        >
          <div style={{ height: "67px", width: "67px" }}>
            <img
              style={{
                width: "37rem",
                "max-width": "100%",
                "border-radius": "33px",
              }}
              src={usericon}
            />
          </div>
          <div style={{ "margin-left": "21px" }}>
            <h3 style={{ "text-transform": "capitalize", color: "#384F6F" }}>
              {props && props.profileData.name}
            </h3>
            <p style={{ color: "#718198", fontSize: "13px" }}>
              {props && props.profileData.mobileNo}
            </p>
          </div>
        </div>

        <div
          className="styles_row__1ivP1 shadow-box"
          data-testid="grid-row"
          style={{
            marginBottom: 24,
            backgroundColor: "white",
            "border-radius": "10px",
            "margin-right": "12px",
            "margin-left": "12px",
            "border-radius": "16px",
            background: "#FFF",
            "box-shadow": "0px 2px 24px 0px rgba(0, 0, 0, 0.08)",
            "border-left": "4px solid",
          }}
        >
          <div onClick={props.goToPaymentsOption}>
            <div className="styles_slide__2c207" style={{ marginRight: 0 }}>
              <div>
                <div
                  className="styles_cardWithPadding__JE1QE"
                  data-testid="home-restaurant-card-wrapper"
                  style={{
                    width: "calc((100vw - 0px) - 12px)",
                    "margin-top": "6px",
                  }}
                >
                  <div
                    data-testid="resturant-card-anchor-container"
                    className="styles_container__fLC0R"
                    tabIndex={0}
                    role="button"
                  >
                    <div
                      className="styles_imgContainer__1uHo5"
                      style={{
                        display: "flex",
                        "align-items": "center",
                        width: "99%",
                      }}
                    >
                      <div
                        className=""
                        data-testid="resturant-card-image-container"
                        style={{
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-evenly",
                        }}
                      >
                        <img
                          loading="lazy"
                          data-testid="resturant-card-image"
                          src={paymenticon}
                          style={{ width: "46px", height: "46px" }}
                        />
                      </div>
                      <div>
                        <h3
                          style={{
                            color: "#384F6F",
                            "font-family": "Roboto",
                            "font-size": "15px",
                            "font-style": "normal",
                            "font-weight": "400",
                            "line-height": "20px",
                            "margin-left": "24px",
                          }}
                        >
                          Payment Settings
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div />
              </div>
            </div>
          </div>
        </div>
      

        <div
          className="styles_row__1ivP1 shadow-box"
          data-testid="grid-row"
          style={{
            marginBottom: 24,
            backgroundColor: "white",
            "border-radius": "10px",
            "margin-right": "12px",
            "margin-left": "12px",
            "border-radius": "16px",
            background: "#FFF",
            "box-shadow": "0px 2px 24px 0px rgba(0, 0, 0, 0.08)",
            "border-left": "4px solid #00B177",
          }}
        >
          <div onClick={props.goToAddTag}>
            <div className="styles_slide__2c207" style={{ marginRight: 0 }}>
              <div>
                <div
                  className="styles_cardWithPadding__JE1QE"
                  data-testid="home-restaurant-card-wrapper"
                  style={{
                    width: "calc((100vw - 0px) - 12px)",
                    "margin-top": "6px",
                  }}
                >
                  <div
                    data-testid="resturant-card-anchor-container"
                    className="styles_container__fLC0R"
                    tabIndex={0}
                    role="button"
                  >
                    <div
                      className="styles_imgContainer__1uHo5"
                      style={{
                        display: "flex",
                        "align-items": "center",
                        width: "99%",
                      }}
                    >
                      <div
                        className=""
                        data-testid="resturant-card-image-container"
                        style={{
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-evenly",

                          width: "48px",
                          height: "44px",
                          background: "ghostwhite",
                          "border-radius": "24px",
                        }}
                      >
                        <img
                          loading="lazy"
                          data-testid="resturant-card-image"
                          src={TagIcon}
                          style={{ width: "40px", height: "32px" }}
                        />
                      </div>
                      <div>
                        <h3
                          style={{
                            color: "#384F6F",
                            "font-family": "Roboto",
                            "font-size": "15px",
                            "font-style": "normal",
                            "font-weight": "400",
                            "line-height": "20px",
                            "margin-left": "24px",
                          }}
                        >
                          TagPay
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div />
              </div>
            </div>
          </div>
        </div>
        <div
          className="styles_row__1ivP1 shadow-box"
          data-testid="grid-row"
          style={{
            marginBottom: 24,
            backgroundColor: "white",
            "border-radius": "10px",
            "margin-right": "12px",
            "margin-left": "12px",
            "border-radius": "16px",
            background: "#FFF",
            "box-shadow": "0px 2px 24px 0px rgba(0, 0, 0, 0.08)",
            "border-left": "4px solid",
          }}
        >
          <div onClick={goToGiftCard}>
            <div className="styles_slide__2c207" style={{ marginRight: 0 }}>
              <div>
                <div
                  className="styles_cardWithPadding__JE1QE"
                  data-testid="home-restaurant-card-wrapper"
                  style={{
                    width: "calc((100vw - 0px) - 12px)",
                    "margin-top": "6px",
                  }}
                >
                  <div
                    data-testid="resturant-card-anchor-container"
                    className="styles_container__fLC0R"
                    tabIndex={0}
                    role="button"
                  >
                    <div
                      className="styles_imgContainer__1uHo5"
                      style={{
                        display: "flex",
                        "align-items": "center",
                        width: "99%",
                      }}
                    >
                            <div
                        className=""
                        data-testid="resturant-card-image-container"
                        style={{
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-evenly",

                          width: "48px",
                          height: "44px",
                          background: "ghostwhite",
                          "border-radius": "24px",
                        }}
                      >
                        <img
                          loading="lazy"
                          data-testid="resturant-card-image"
                          src={GiftCard}
                          style={{ width: "40px", height: "32px" }}
                        />
                      </div>
                      <div>
                        <h3
                          style={{
                            color: "#384F6F",
                            "font-family": "Roboto",
                            "font-size": "15px",
                            "font-style": "normal",
                            "font-weight": "400",
                            "line-height": "20px",
                            "margin-left": "24px",
                          }}
                        >
                         Gift Card 
                        </h3>
                        <p style={{fontSize:"12px",fontWeight:"400",marginLeft:"24px",color:"rgba(56, 79, 111, 0.7)"}}>Claim, and Keep Track of Gift Cards</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div />
              </div>
            </div>
          </div>
        </div> 

        <div
          className="styles_row__1ivP1 shadow-box"
          data-testid="grid-row"
          style={{
            marginBottom: 24,
            backgroundColor: "white",
            "border-radius": "10px",
            "margin-right": "12px",
            "margin-left": "12px",
            "border-radius": "16px",
            background: "#FFF",
            "box-shadow": "0px 2px 24px 0px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div className="styles_slide__2c207" style={{ marginRight: 0 }}>
            <div>
                 <div
              className="styles_cardWithPadding__JE1QE"
              data-testid="home-restaurant-card-wrapper"
              style={{
                width: "calc((100vw - 0px) - 12px)",
                
              }}
            >
              <div
                data-testid="resturant-card-anchor-container"
                className="styles_container__fLC0R"
                tabIndex={0}
                role="button"
              >
                <div
                  className="styles_imgContainer__1uHo5"
                  style={{ display: "flex", "align-items": "center" ,width:"100%",width:"99%",
                  }}
                >
                  <div
                    className="styles_ImageContainer__2rk9a"
                    data-testid="resturant-card-image-container"
                    style={{
                      background: "white",
                      width: "55px",
                      height: "56px",
                      "border-radius": "27px",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-evenly",
                    }}
                  >
                    <img
                      className="styles_Image__1fplJ"
                      loading="lazy"
                      data-testid="resturant-card-image"
                      src={helpfaq}
                      style={{ width: "36px", height: "36px",background:"white" }}

                    />
                  </div>
                 <Link to='/faq' style={{textDecoration:"none",width:"100%",color:"black"}}> <div style={{display:"flex",width:"93%","justify-content":"space-between"}}>
                  <h3 style={{ "margin-left": "21px", color: "#384F6F",
"text-align": "center",
"font-family": "Roboto",
"font-size": "15px",
"font-style": "normal",
"font-weight":"400",
"line-height": "normal",marginLeft:"31px" }}>Help & Support</h3>
           <img  style={{width:"10px"}}src={nextArrow}/> 
                  </div>
                  </Link>

              
                </div>
              </div>
            </div> 
         
            </div>
            <div>
                 <div
              className="styles_cardWithPadding__JE1QE"
              data-testid="home-restaurant-card-wrapper"
              style={{
                width: "calc((100vw - 0px) - 12px)",
                
              }}
            >
              <div
                data-testid="resturant-card-anchor-container"
                className="styles_container__fLC0R"
                tabIndex={0}
                role="button"
              >
                <div
                  className="styles_imgContainer__1uHo5"
                  style={{ display: "flex", "align-items": "center" ,width:"100%",width:"99%",
                  }}
                >
                  <div
                    className="styles_ImageContainer__2rk9a"
                    data-testid="resturant-card-image-container"
                    style={{
                      background: "white",
                      width: "55px",
                      height: "56px",
                      "border-radius": "27px",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-evenly",
                    }}
                  >
                    <img
                      className="styles_Image__1fplJ"
                      loading="lazy"
                      data-testid="resturant-card-image"
                      src={ReferICon}
                      style={{ width: "36px", height: "36px",background:"white" }}

                    />
                  </div>
                 <Link to='/refer&earn' style={{textDecoration:"none",width:"100%",color:"black"}}> <div style={{display:"flex",width:"93%","justify-content":"space-between"}}>
                  <h3 style={{ "margin-left": "21px", color: "#384F6F",
"text-align": "center",
"font-family": "Roboto",
"font-size": "15px",
"font-style": "normal",
"font-weight":"400",
"line-height": "normal",marginLeft:"31px" }}>Refer and Earn</h3>
           <img  style={{width:"10px"}}src={nextArrow}/> 
                  </div>
                  </Link>

              
                </div>
              </div>
            </div> 
         
            </div>
            <div>
              <div
                className="styles_cardWithPadding__JE1QE"
                data-testid="home-restaurant-card-wrapper"
                style={{
                  width: "calc((100vw - 0px) - 12px)",
                }}
              >
                <div
                  data-testid="resturant-card-anchor-container"
                  className="styles_container__fLC0R"
                  tabIndex={0}
                  role="button"
                >
                  <div
                    className="styles_imgContainer__1uHo5"
                    style={{
                      display: "flex",
                      "align-items": "center",
                      width: "100%",
                      width: "99%",
                      marginLeft: "9px",
                    }}
                  >
                    <div
                      className="styles_ImageContainer__2rk9a"
                      data-testid="resturant-card-image-container"
                      style={{
                        background: "white",
                        width: "55px",
                        height: "56px",
                        "border-radius": "27px",
                        display: "flex",
                        "align-items": "center",
                      }}
                    >
                      <img
                        className="styles_Image__1fplJ"
                        loading="lazy"
                        data-testid="resturant-card-image"
                        src={faqicon}
                        style={{
                          width: "36px",
                          height: "36px",
                          background: "white",
                        }}
                      />
                    </div>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        width: "100%",
                      }}
                      href="https://www.daalchini.co.in/faq.html"
                    >
                      {" "}
                      <div
                        style={{
                          width: "91%",
                          display: "flex",
                          "justify-content": "space-between",
                        }}
                      >
                        <h3
                          style={{
                            color: "#384F6F",
                            "text-align": "center",
                            "font-family": "Roboto",
                            "font-size": "15px",
                            "font-style": "normal",
                            "font-weight": "400",
                            "line-height": "normal",
                            "margin-left": "27px",
                          }}
                        >
                          FAQ'S
                        </h3>
                        <img style={{ width: "10px" }} src={nextArrow} />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div />
            </div>
            <div>
              <div
                className="styles_cardWithPadding__JE1QE"
                data-testid="home-restaurant-card-wrapper"
                style={{
                  width: "calc((100vw - 0px) - 12px)",
                }}
              >
                <div
                  data-testid="resturant-card-anchor-container"
                  className="styles_container__fLC0R"
                  tabIndex={0}
                  role="button"
                >
                  <div
                    className="styles_imgContainer__1uHo5"
                    style={{
                      display: "flex",
                      "align-items": "center",
                      width: "100%",
                      width: "99%",
                    }}
                  >
                    <div
                      className="styles_ImageContainer__2rk9a"
                      data-testid="resturant-card-image-container"
                      style={{
                        background: "white",
                        width: "55px",
                        height: "56px",
                        "border-radius": "27px",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "space-evenly",
                      }}
                    >
                      <img
                        className="styles_Image__1fplJ"
                        loading="lazy"
                        data-testid="resturant-card-image"
                        src={Aboutusicon}
                        style={{
                          width: "36px",
                          height: "36px",
                          background: "white",
                        }}
                      />
                    </div>
                    <a
                      href="https://www.daalchini.co.in/"
                      style={{
                        textDecoration: "none",
                        width: "100%",
                        color: "black",
                      }}
                    >
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          width: "93%",
                          "justify-content": "space-between",
                        }}
                      >
                        <h3
                          style={{
                            "margin-left": "21px",
                            color: "#384F6F",
                            "text-align": "center",
                            "font-family": "Roboto",
                            "font-size": "15px",
                            "font-style": "normal",
                            "font-weight": "400",
                            "line-height": "normal",
                            marginLeft: "31px",
                          }}
                        >
                          About Us
                        </h3>
                        <img style={{ width: "10px" }} src={nextArrow} />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div />
            </div>
            <div>
              <div />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Userprofile;
